<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xiii"><i>CONTENTS</i></a></p><a id="page_xiii">
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="20%"/>
<col width="80%"/>
</colgroup><tbody><tr>
<td colspan="2" valign="top"><p class="toct"><a href="#/xhtml/11_Fm04">PROLOGUE</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toct"><a href="#/xhtml/12_Part01"><b>PART ONE</b></a></p></td>
<td valign="top"><p class="toct"><a href="#/xhtml/12_Part01"><b>DESCENT INTO DARKNESS</b></a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/xhtml/13_Chapter01">CHAPTER 1</a></p></td>
<td valign="top"><p class="toc"><a href="#/xhtml/13_Chapter01">Blue Eyes</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/14_Chapter02" title="Link target outside of Sample">CHAPTER 2</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/14_Chapter02" title="Link target outside of Sample">Liquid Confidence</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/15_Chapter03" title="Link target outside of Sample">CHAPTER 3</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/15_Chapter03" title="Link target outside of Sample">Dart Boards</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/16_Chapter04" title="Link target outside of Sample">CHAPTER 4</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/16_Chapter04" title="Link target outside of Sample">Dashed Hopes</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample">CHAPTER 5</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample">ABV</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample">CHAPTER 6</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample">Seeking Support</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/19_Chapter07" title="Link target outside of Sample">CHAPTER 7</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/19_Chapter07" title="Link target outside of Sample">Blind Man’s Bluff</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/20_Chapter08" title="Link target outside of Sample">CHAPTER 8</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/20_Chapter08" title="Link target outside of Sample">Shattered Beauty</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/21_Chapter09" title="Link target outside of Sample">CHAPTER 9</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/21_Chapter09" title="Link target outside of Sample">Finding Faith</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/22_Chapter10" title="Link target outside of Sample">CHAPTER 10</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/22_Chapter10" title="Link target outside of Sample">Brave New World</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/23_Chapter11" title="Link target outside of Sample">CHAPTER 11</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/23_Chapter11" title="Link target outside of Sample">A New Angle</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/24_Chapter12" title="Link target outside of Sample">CHAPTER 12</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/24_Chapter12" title="Link target outside of Sample">Les</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/25_Chapter13" title="Link target outside of Sample">CHAPTER 13</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/25_Chapter13" title="Link target outside of Sample">Wardrobe Madness</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/26_Chapter14" title="Link target outside of Sample">CHAPTER 14</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/26_Chapter14" title="Link target outside of Sample">Lost and Found</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/27_Chapter15" title="Link target outside of Sample">CHAPTER 15</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/27_Chapter15" title="Link target outside of Sample">Rugged Ruger</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/28_Chapter16" title="Link target outside of Sample">CHAPTER 16</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/28_Chapter16" title="Link target outside of Sample">Pencil Man</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/29_Chapter17" title="Link target outside of Sample">CHAPTER 17</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/29_Chapter17" title="Link target outside of Sample">Bent Knees</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/30_Chapter18" title="Link target outside of Sample">CHAPTER 18</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/30_Chapter18" title="Link target outside of Sample">The Bowery</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toct"><a id="page_xiv"></a><span href="#/xhtml/31_Part02" title="Link target outside of Sample"><b>PART TWO</b></span></p></td>
<td valign="top"><p class="toct"><span href="#/xhtml/31_Part02" title="Link target outside of Sample"><b>AMAZING GRACE</b></span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/32_Chapter19" title="Link target outside of Sample">CHAPTER 19</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/32_Chapter19" title="Link target outside of Sample">Angels Among Us</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/33_Chapter20" title="Link target outside of Sample">CHAPTER 20</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/33_Chapter20" title="Link target outside of Sample">Blind Injustice</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/34_Chapter21" title="Link target outside of Sample">CHAPTER 21</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/34_Chapter21" title="Link target outside of Sample">Random Acts of Kindness</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/35_Chapter22" title="Link target outside of Sample">CHAPTER 22</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/35_Chapter22" title="Link target outside of Sample">Words</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/36_Chapter23" title="Link target outside of Sample">CHAPTER 23</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/36_Chapter23" title="Link target outside of Sample">Bumper Cars</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/37_Chapter24" title="Link target outside of Sample">CHAPTER 24</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/37_Chapter24" title="Link target outside of Sample">The Christmas Present</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/38_Chapter25" title="Link target outside of Sample">CHAPTER 25</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/38_Chapter25" title="Link target outside of Sample">Au Revoir, Ruger</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/39_Chapter26" title="Link target outside of Sample">CHAPTER 26</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/39_Chapter26" title="Link target outside of Sample">Soufflé and Elias</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/40_Chapter27" title="Link target outside of Sample">CHAPTER 27</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/40_Chapter27" title="Link target outside of Sample">Crossing Bridges</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/41_Chapter28" title="Link target outside of Sample">CHAPTER 28</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/41_Chapter28" title="Link target outside of Sample">Itchy Feet</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/42_Chapter29" title="Link target outside of Sample">CHAPTER 29</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/42_Chapter29" title="Link target outside of Sample">Cheryl’s Prayer</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/43_Chapter30" title="Link target outside of Sample">CHAPTER 30</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/43_Chapter30" title="Link target outside of Sample">One Last Kiss</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/44_Chapter31" title="Link target outside of Sample">CHAPTER 31</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/44_Chapter31" title="Link target outside of Sample">In Focus</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/45_Chapter32" title="Link target outside of Sample">CHAPTER 32</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/45_Chapter32" title="Link target outside of Sample">Snowfall</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/46_Chapter33" title="Link target outside of Sample">CHAPTER 33</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/46_Chapter33" title="Link target outside of Sample">The Yellow Cab</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toct"><span href="#/xhtml/47_Epilogue" title="Link target outside of Sample">EPILOGUE</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toct"><span href="#/xhtml/48_Bm01" title="Link target outside of Sample">KEVIN TODAY</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toct"><span href="#/xhtml/49_Appendix1" title="Link target outside of Sample"><i><b>APPENDIX A</b></i></span></p></td>
<td valign="top"><p class="toct"><span href="#/xhtml/49_Appendix1" title="Link target outside of Sample">KEVIN’S JOURNAL</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toct"><span href="#/xhtml/50_Appendix2" title="Link target outside of Sample"><i><b>APPENDIX B</b></i></span></p></td>
<td valign="top"><p class="toct"><span href="#/xhtml/50_Appendix2" title="Link target outside of Sample">PROLOGUE -<br/>EXCERPT FROM INFLECTION POINT</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toct"><span href="#/xhtml/51_Author" title="Link target outside of Sample">ABOUT THE AUTHORS</span></p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Contents.vue?7b90848a